// import { set } from '@/utils/vuex'

export default {
  setAPI: (state, API) => {
    state.API = API;
  },
};
